import styled from 'styled-components'
import { TextInput } from '@usap/uicomponents'

export const StyledContainer = styled.div`
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  gap: 16px;
  display: flex;
  flex-direction: column;
`

export const StyledSubtitle = styled.div`
  margin-top: 16px;
  color: #3E3E47;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;

  & > small {
    font-size: 12px;
  }
`

export const StyledTextInputContainer = styled.div`
  flex-grow: 1;
`

export const StyledTextInput = styled(TextInput)<{ error?: boolean}>`
    font-size: 16px;
    color: ${({ error }) => (error ? '#CC3333' : '#282832')};
    font-weight: 400;
    box-shadow: none;
    border: 1px solid  ${({ error }) => (error ? '#CC3333' : '#939398')};
    height: 48px;
    padding: 0px 16px 0px 16px
    border-radius: 4px
`

export const StyledCheckBoxLabel = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
`

export const StyledTextInputError = styled.div`
  color: #CC3333;
  font-size: 12px;
  padding: 4px 0px 0px 8px;
`
